import { reactive } from 'vue';

const STORAGE_KEY = 'tmcollection_auth';

function loadStored() {
	try {
		return JSON.parse(localStorage.getItem(STORAGE_KEY));
	} catch {
		return null;
	}
}

const stored = loadStored();
let token = stored ? stored.token : null;

const state = reactive({
	isLoggedIn: !!token,
	username: stored ? stored.username : null,
});

function persist() {
	if (token) {
		localStorage.setItem(STORAGE_KEY, JSON.stringify({ token, username: state.username }));
	} else {
		localStorage.removeItem(STORAGE_KEY);
	}
}

function authHeaders() {
	return token ? { Authorization: `Bearer ${token}` } : {};
}

async function login(username, password) {
	try {
		const res = await fetch(`${process.env.BASE_URL}api/login`, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ username, password }),
		});
		if (!res.ok) return false;
		const data = await res.json();
		token = data.token;
		state.username = data.username;
		state.isLoggedIn = true;
		persist();
		return true;
	} catch {
		return false;
	}
}

async function logout() {
	try {
		await fetch(`${process.env.BASE_URL}api/logout`, { method: 'POST', headers: authHeaders() });
	} catch {
		// ignore network errors on logout
	}
	token = null;
	state.username = null;
	state.isLoggedIn = false;
	persist();
}

async function verifySession() {
	if (!token) return;
	try {
		const res = await fetch(`${process.env.BASE_URL}api/me`, { headers: authHeaders() });
		if (!res.ok) {
			token = null;
			state.username = null;
			state.isLoggedIn = false;
			persist();
		}
	} catch {
		// network error - keep the optimistic local state
	}
}

verifySession();

export default { state, login, logout, authHeaders };
